import { SsrCompatiblePortal } from '@gs-ux-uitoolkit-react/shared';
import { PropsWithChildren, FC } from 'react';

export const MenuPortal: FC<PropsWithChildren<{ appendToBody: boolean }>> = ({
    appendToBody,
    children,
}) => (appendToBody ? <SsrCompatiblePortal>{children}</SsrCompatiblePortal> : <>{children}</>);
